<template>
  <el-container class="f-h">
    <el-header class="toolbar" style="height: 2.5rem">
      <el-row type="flex" justify="space-between">
        <el-col class="sub-title left" :span="8">
          挂号：
          <el-button type="primary" size="small" icon="el-icon-document-add" @click="register" v-if="permission.registration_registry_create">门诊挂号</el-button>
          <id-reader @ok="receiveIdCard" :is-used-dialog="false" text="读取身份证并挂号" />
          <el-button plain type="info" size="small" icon="el-icon-setting" @click="printConfig">打印机配置</el-button>
        </el-col>
        <el-col :span="2"> </el-col>
        <el-col class="right" :span="14">
          <dateRangePicker
            :defaultVal="[condition.startDate, condition.endDate]"
            :start.sync="condition.startDate"
            :end.sync="condition.endDate"
            @change="lodingData"
            nextWeek
            widthIsSmall
          />
          <staff-selector v-model="condition.registrarName" :dept="user.deptCode" placeholder="挂号员" class="edit-input left-pad" @change="page"></staff-selector>
          <el-select v-model="condition.targetId" size="small" placeholder="号别" class="condition-input" filterable clearable @change="page">
            <el-option v-for="item in validTargets" :key="item.id" :value="item.id" :label="item.targetType == '科室' ? item.deptName : item.doctorName">
              <span v-if="item.targetType == '科室'">{{ item.deptCode | dictText("Dept") }}</span>
              <span v-if="item.targetType == '专家'">
                <small style="color: #bbb">{{ item.deptCode | dictText("Dept") }}：</small>{{ item.doctorName }}</span>
            </el-option>
          </el-select>
          <el-input size="small" class="condition-wide left-pad" type="text" clearable placeholder="卡号或患者姓名" v-model="condition.keyword" @keyup.enter.native="page" @clear="page">
            <el-button size="small" slot="append" @click="page" :disabled="meta.loading" icon="el-icon-search"></el-button>
          </el-input>
        </el-col>
      </el-row>
    </el-header>
    <el-main style="padding: 0px">
      <el-table @filter-change="filterChanged" :data="entities.items" stripe height="91%" v-loading="meta.loading" @sort-change="handleSortChange">
        <!-- <el-table-column label="操作" align="center" width="150">
          <template slot-scope="{ row }">
            <el-button v-if="permission.registration_registry_delete" title="退号" type="danger" plain size="mini" circle icon="el-icon-delete" :disabled="row.state == '就诊' || row.ifDoctorAdd" @click="refund(row)"></el-button>
            <el-button v-if="true || permission.registration_registry_info" title="详细" type="info" plain size="mini" circle icon="el-icon-search" class="left-pad" @click="view(row)"></el-button>
          </template>
        </el-table-column> -->
        <el-table-column sortable="custom" label="就诊号" prop="opNo" min-width="150" align="center">
          <template slot-scope="{ row }">
            <el-link type="primary" @click="view(row)">{{ row.opNo }}</el-link>
          </template>
        </el-table-column>
        <el-table-column sortable="custom" label="状态" prop="state" align="center">
          <template slot-scope="{ row }">
            <el-tag v-if="row.state == '就诊'" type="danger" size="small" effect="plain">{{ row.state }}</el-tag>
            <el-tag v-else-if="row.state == '报到'" type="success" size="small" effect="plain">{{ row.state }}</el-tag>
            <el-tag v-else-if="row.state == '取号'" type="warning" size="small" effect="plain">{{ row.state }}</el-tag>
            <el-tag v-else size="small" type="info" effect="plain">{{ row.state }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column sortable="custom" label="支付" prop="state" align="center">
          <template slot-scope="{ row }">
            <el-tag v-if="row.paymentState == '退款'" type="danger" size="small" effect="plain">{{ row.paymentState }}</el-tag>
            <el-tag v-else-if="row.paymentState == '收款'" type="success" size="small" effect="plain">{{ row.paymentState }}</el-tag>
            <el-tag v-else size="small" type="info" effect="plain">未支付</el-tag>
          </template>
        </el-table-column>
        <el-table-column sortable="custom" min-width="120" :filters="validRegTypes" :filter-multiple="false" column-key="regType" label="号别" prop="regType">
          <template slot-scope="{ row }">
            {{ row.regType | dictText("RegType") }}
          </template>
        </el-table-column>
        <el-table-column sortable="custom" label="科室医师" prop="deptCode" align="left" width="150">
          <template slot-scope="{ row }">
            {{ row.deptCode | dictText("Dept") }}
            {{ row.doctorName }}
          </template>
        </el-table-column>
        <el-table-column sortable="custom" label="患者" prop="patientName"></el-table-column>
        <el-table-column label="性别" prop="patientGender" width="60">
          <template slot-scope="scope">
            {{ scope.row.patientGender | dictText("Gender") }}
          </template>
        </el-table-column>
        <el-table-column label="年龄" prop="patientAge" width="60"></el-table-column>
        <el-table-column label="就诊类型" :filters="dictEnum.OpType" :filter-multiple="false" column-key="opType" prop="opType" width="100" align="center">
          <template slot-scope="{ row }">
            <el-tag v-if="row.opType == '医保工伤'" type="danger" size="small" effect="plain">{{ row.opType }}</el-tag>
            <el-tag v-else-if="row.opType == '医保'" type="warning" size="small" effect="plain">{{ row.opType }}</el-tag>
            <el-tag v-else type="success" size="small" effect="plain">{{ row.opType }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column sortable="custom" label="日期" prop="date" width="100">
          <template slot-scope="{ row }">
            {{ row.date | fmtDate }}
          </template>
        </el-table-column>
        <el-table-column label="午别" :filters="dictEnum.PeriodType" :filter-multiple="false" column-key="periodType" prop="periodType" align="center"></el-table-column>
        <el-table-column label="候诊时段" prop="periodStart" align="center" width="100">
          <template slot-scope="{ row }">
            <span v-if="row.periodStart">{{ row.periodStart + "~" + row.periodEnd }}</span>
          </template>
        </el-table-column>
        <el-table-column label="序号" prop="seqNo" align="center"></el-table-column>
        <el-table-column label="生育险" prop="ifMaternityInsurance" align="center">
          <template slot-scope="{ row }">
            <el-tag v-if="row.ifMaternityInsurance" type="danger">是</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="医生加号" prop="ifDoctorAdd" align="center">
          <template slot-scope="{ row }">
            <el-tag v-if="row.ifDoctorAdd" type="danger">是</el-tag>
          </template>
        </el-table-column>
        <el-table-column column-key="criticalLevel" :filters="dictEnum.CriticalLevel" :filter-multiple="false" label="危重等级" min-width="100" prop="criticalLevel" align="center">
          <template slot-scope="{ row }">
            <el-tag v-if="row.criticalLevel == Enum.CriticalLevel.濒危" type="danger" effect="dark" size="small">{{ row.criticalLevel }}</el-tag>
            <el-tag v-else-if="row.criticalLevel == Enum.CriticalLevel.危重" type="danger" hit size="small">{{ row.criticalLevel }}</el-tag>
            <el-tag v-else-if="row.criticalLevel == Enum.CriticalLevel.急症" type="warning" hit size="small">{{ row.criticalLevel }}</el-tag>
            <el-tag v-else-if="row.criticalLevel == Enum.CriticalLevel.非急症" type="info" hit size="small">{{ row.criticalLevel }}</el-tag>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <pagination :entities="entities" @queryEntities="page" :condition="condition" />
    <detail :visible.sync="meta.showDetail" :reg="entity" @refunded="page"></detail>
    <!-- <refund :visible.sync="meta.showRefund" :reg="entity" @ok="page"></refund> -->
    <registry v-if="meta.showRegistry" :visible.sync="meta.showRegistry" :id-card="idCard" @close="page"></registry>
    <printDlg :visible.sync="meta.showPrintDlg" :printNameList="printNameList"></printDlg>
  </el-container>
</template>

<script>
import api from "./api";
import { mapGetters } from "vuex";
import print from "@/common/print.js";
import { getLodop } from "@/common/LodopFuncs";

export default {
  components: {
    detail: () => import("./detail"),
    // refund: () => import("@/components/fee/refundReg"),
    registry: () => import("./registry"),
    pagination: () => import("@/components/_com/pagination"),
    printDlg: () => import("@/components/_com/digDigitalPrint"),
  },
  data () {
    return {
      meta: {
        loading: false,
        showDetail: false,
        showRefund: false,
        showRegistry: false,
        showPrintDlg: false,
      },
      condition: {
        startDate: '',
        endDate: '',
        // date: null,
        stateAfter: "预约",
        paymentState: "收款",
        regTypeCode: null,
        targetId: null,
        periodType: null,
        appointmentChannelCode: null,
        registrarName: null,
        keyword: null,
        pageSize: 20,
        pageIndexOnView: 1,
        sort: "takingDate",
        asc: false,
      },
      entities: {
        items: [],
      },
      entity: {},
      printNameList: [], // 打印机数组
      idCard: null // 身份证信息
    };
  },
  computed: {
    ...mapGetters(["dict", "dictEnum", "Enum", "permission", "user"]),
    channels () {
      try {
        return this.dict.AppointmentChannel.filter((item) => !item.disabled);
      } catch {
        return [];
      }
    },
    validRegTypes () {
      if (!this.dict.RegType) {
        return [];
      }
      return this.dict.RegType.filter((item) => !item.disabled).sort((a, b) => {
        return a.seqNo - b.seqNo;
      });
    },
    validTargets () {
      if (!this.dict.OpTarget) {
        return [];
      }
      return this.dict.OpTarget.filter((item) => item).sort((a, b) => {
        return a.deptCode != b.deptCode ? a.deptCode.localeCompare(b.deptCode) : (a.doctorId || 0) - (b.doctorId || 0);
      });
    },
  },
  created () {
    // 检测到本地打印机设置
    if (!localStorage.getItem("printerConfig")) {
      this.printConfig();
    }
    // 初始化德卡ws
    this.$store.dispatch("deCardWsInit", {
      message: this.$message,
      callback: () => {},
    });
  },
  methods: {
    // 获取打印机数据
    printConfig () {
      this.LODOP = getLodop(); // 创建一个LODOP对象
      // mac this.LODOP.GET_SYSTEM_INFO('NetworkAdapter.1.PhysicalAddress')
      let counter = this.LODOP.GET_PRINTER_COUNT(); // 获取打印机个数
      console.log("获取打印机个数", counter);
      //初始化下printNameList打印数组
      this.printNameList = [];
      for (let i = 0; i < counter; i++) {
        //将打印机存入printList数组中
        this.printNameList.push(this.LODOP.GET_PRINTER_NAME(i));
      }
      console.log("this.printNameList", this.printNameList);
      this.meta.showPrintDlg = true;
    },
    handleSortChange ({ prop, order }) {
      this.condition.asc = order === "ascending";
      this.condition.sort = prop;
      this.page();
    },
    filterChanged (options) {
      Object.assign(this.condition, options);
      this.page();
    },
    async lodingData () {
      // this.condition.date = this.$utils.fmtDate(this.$utils.serverTime);
      await this.page();
    },
    register () {
      this.meta.showRegistry = true;
      this.idCard = null;
    },
    view (row) {
      this.entity = this.$utils.clone(row);
      this.meta.showDetail = true;
    },
    // refund(row) {
    //   if (row.state == this.Enum.RegState.就诊) {
    //     this.$message.error("就诊号是已就诊状态，禁止退款！");
    //   }
    //   this.entity = this.$utils.clone(row);
    //   this.$nextTick(() => {
    //     this.meta.showRefund = true;
    //   });
    // },
    print (row) {
      print.regVoucher(row, { paymentType: "" });
      // this.$message({ message: "todo!", type: "info" });
    },
    async page () {
      this.meta.loading = true;
      await api
        .queryReg(this.condition)
        .then((res) => {
          // res.items.forEach((item) => {
          //   if (item.cardNo) {
          //     item.cardNo = item.cardNo.substr(0, 4) + "..." + item.cardNo.substr(item.cardNo.length - 4);
          //   }
          // });
          this.entities = res;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.meta.loading = false;
        })
    },
    // 接收身份证读卡信息
    receiveIdCard (data) {
      this.meta.showRegistry = true;
      this.idCard = data;
    }
  }
}
</script>

<style scoped>
.wedge-left {
  margin-left: 5px;
}
</style>
